module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    class: {
      'landing-page': _vm.isLandingPage
    }
  }, [_vm._v("\n  ©2010-" + _vm._s(new Date().getFullYear()) + " Alexy Üvegtechnika Orosháza Kft.\n\n  "), (_vm.isLandingPage) ? _c('div', [_c('router-link', {
    staticClass: "statement-link",
    attrs: {
      "to": "/adatvedelmi-nyilatkozat"
    }
  }, [_vm._v("\n      Adatvédelmi nyilatkozat\n    ")]), _vm._v("\n    |\n    "), _c('router-link', {
    staticClass: "statement-link",
    attrs: {
      "to": "/jogi-nyilatkozat"
    }
  }, [_vm._v("\n      Jogi nyilatkozat\n    ")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a423f0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foot.vue
// module id = 951
// module chunks = 0